// src/Components/Data/department.js

export const DEPARTMENTS = [
  { label: "ICT", value: "ICT" },
  { label: "HR", value: "HR" },
  { label: "Kitchen", value: "Kitchen" },
  { label: "Front Office", value: "Front Office" },
  { label: "Store", value: "Store" },
  { label: "Account", value: "Account" },
  { label: "Audit", value: "Audit" },
  { label: "F&B", value: "F&B" },
  { label: "House keeping", value: "House keeping" },
  { label: "Maintenance", value: "Maintenance" },
  { label: "Garden", value: "Garden" },
  { label: "Reservation", value: "Reservation" },
  { label: "Resturant", value: "Resturant" },
  { label: "Procurement", value: "Procurement" },
  { label: "Reception", value: "Reception" },
  { label: "Laundry", value: "Laundry" },
  { label: "Compliance", value: "Compliance" },
  { label: "SPA", value: "SPA" },
  { label: "GYM", value: "GYM" },
  { label: "Naturalist", value: "Naturalist" },
  { label: "Yoga", value: "Yoga" },
  { label: "Marketing", value: "Marketing" },
  { label: "Admin", value: "Admin" },
  {label: "Transport", value: "Transport"},
  { label: "Safety", value: "Safety" },
  { label: "SwimShop", value: "SwimShop" },
  {label: "DJ", value: "DJ"},
  { label: "Outlet", value: "Outlet" },
  {label : "Production", value: "Production"},
];


    
    
    
    
    
   
    
   
   
    
    
   
    
   
    
    
    